/**
 * Research 횟수 React Query 키 — 사이드바 RESEARCH 표제의 셈과 Research 화면의 관문(`ResearchQuotaProvider`)이 같은 캐시를 본다.
 */
export const researchKeys = {
  all: ['research'] as const,

  /** 이번 달 쓴 수 · 한도(`readResearchUsage`) — 워크스페이스마다 */
  usage: (workspaceId: string) => [...researchKeys.all, 'usage', workspaceId] as const,
};
